<script lang="ts" setup>
import { computedAsync } from '@vueuse/core';
import { Translation } from 'vue-i18n';

import {
  useRouterStore,
  useStatsigEventsStore,
} from '@apps/main/new-desktop/core/stores';

import {
  AppButton,
  SemboStarIllustration,
  SemboHeartIllustration,
} from '@libs/ui';
import { isExperimentAsync } from '@libs/feature-toggle';

interface GenericHotelCardMobileProps {
  ingredientIndex: number;
  destination: string;
  amountAccommodationsInDestination?: number;
}

const props = defineProps<GenericHotelCardMobileProps>();

const statsigEventsStore = useStatsigEventsStore();
const routerStore = useRouterStore();

const isCarouselLastCardCopyUpdateExperiment = computedAsync(
  () => isExperimentAsync('carousel_last_card_copy_update'),
  false
);
function openHotelSelection(): void {
  statsigEventsStore.logTripOverviewAlternativeHotelsHotelSelectionCardClicked();
  routerStore.navigateToHotelSelection({
    ingredientIndex: props.ingredientIndex,
  });
}
</script>

<template>
  <button class="generic-hotel-card-mobile" @click="openHotelSelection()">
    <Translation
      v-if="
        isCarouselLastCardCopyUpdateExperiment &&
        amountAccommodationsInDestination
      "
      class="title"
      keypath="planner.alternative_hotels.more_than_suggestions"
      tag="span"
    >
      <template #destination>{{ props.destination }}</template>
      <template #amount>{{ amountAccommodationsInDestination }}</template>
    </Translation>
    <span v-else class="title">
      {{ $t('planner.alternative_hotels.generic_card_title') }}
    </span>
    <AppButton type="secondary" size="medium" state="enabled">
      {{ $t('planner.alternative_hotels.change_hotel') }}
    </AppButton>
    <SemboStarIllustration class="star-illustration" />
    <SemboHeartIllustration class="heart-illustration" />
  </button>
</template>

<style lang="scss" scoped>
.generic-hotel-card-mobile {
  all: unset;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 100%;
  width: calc(100% - 30px);
  gap: var(--spacing-24);
  background-color: var(--color-neutral-10);
  border-radius: var(--border-radius-12);
  margin-right: 0;
  overflow: hidden;

  .title {
    color: var(--color-soft-black);
    @include font-label-m-bold;
    line-height: var(--line-heights-16);
    text-align: center;
    padding: 0 var(--spacing-16);
  }

  .heart-illustration {
    position: absolute;
    top: 9px;
    left: 40px;
  }
  .star-illustration {
    position: absolute;
    bottom: -18px;
    right: 25px;
  }
}
</style>
